import React from 'react';

import { TextField, ToggleSwitch } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { lang, remCss } from 'src/helpers';

import model from './model';
import NavigationButtons from './NavigationButtons';
import LANG_CONST from 'src/helpers/lang/const';

const chatTicketDurationOptions = [
  { value: 1, label: `1 ${lang.t('Days')}` },
  { value: 2, label: `2 ${lang.t('Days')}` },
  { value: 3, label: `3 ${lang.t('Days')}` },
  { value: 4, label: `4 ${lang.t('Days')}` },
  { value: 5, label: `5 ${lang.t('Days')}` },
  { value: 7, label: `1 ${lang.t('Week')}` },
  { value: 14, label: `2 ${lang.t('Weeks')}` },
  { value: 21, label: `3 ${lang.t('Weeks')}` },
  { value: 30, label: `4 ${lang.t('Weeks')}` }
];

export default class ChatTicket extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  getCurrency = () => {
    return model.input('currency');
  };

  renderChatTicket = (dataSet, name, title) => {
    const id = dataSet.id || 'default';
    const data = dataSet[name] || {};
    const { handleCharges } = model;
    const { invalid, loading } = model.getApiState('charges');
    let paid = !!data.paid;
    let alwaysShow = true;

    return (
      <div className={'mc-flex-20-col'} key={'form-group-' + id + '-' + name}>
        <div className={'mc-flex-20'}>
          <div className={'mc-value-518'}>{lang.t(title)}</div>
          <ToggleSwitch
            name='paid'
            checked={paid}
            onChange={() => handleCharges(id, name, 'paid')('paid', !paid)}
          />
        </div>
        {(paid || alwaysShow) && (
          <>
            <div className={'mc-flex-20'}>
              <div className={'mc-grow'}>
                <TextField
                  template={3}
                  type={'money'}
                  currency={this.getCurrency()}
                  placeholder={paid ? LANG_CONST.not_set : LANG_CONST.free}
                  label={LANG_CONST.price}
                  name={'price'}
                  value={paid ? data['price'] || '' : ''}
                  onChange={handleCharges(id, name, 'price')}
                  invalid={invalid[[id, name, 'price'].join('_')]}
                  disabled={loading}
                />
              </div>
              <div className={'mc-grow'}>
                <TextField
                  template={3}
                  type='select'
                  placeholder={LANG_CONST.not_set}
                  label={LANG_CONST.duration}
                  name={'duration'}
                  value={data['duration'] || ''}
                  onChange={handleCharges(id, name, 'duration')}
                  invalid={invalid[[id, name, 'duration'].join('_')]}
                  disabled={loading}
                  inputProps={{
                    minWidth: remCss(150),
                    options: chatTicketDurationOptions
                  }}
                />
              </div>
            </div>
            <div className={'mc-flex-20'}>
              <div className={'mc-grow'}>
                <TextField
                  type='number'
                  template={3}
                  placeholder={LANG_CONST.not_set}
                  label={LANG_CONST.no_of_message}
                  name={'messagesCount'}
                  value={data['messagesCount'] || ''}
                  onChange={handleCharges(id, name, 'messagesCount')}
                  invalid={invalid[[id, name, 'messagesCount'].join('_')]}
                  disabled={loading}
                />
              </div>
              <div className={'mc-grow'}>
                <TextField
                  template={3}
                  type={'money'}
                  currency={this.getCurrency()}
                  placeholder={LANG_CONST.not_set}
                  label={LANG_CONST.extra_message}
                  name={'extraMessage'}
                  value={data['extraMessage'] || ''}
                  onChange={handleCharges(id, name, 'extraMessage')}
                  invalid={invalid[[id, name, 'extraMessage'].join('_')]}
                  disabled={loading}
                />
              </div>
            </div>
          </>
        )}
      </div>
    );
  };

  render() {
    const { charge } = model.state;
    let { error, errorMessage, loading, invalid } = model.getApiState('charges');
    if (invalid && invalid.charge) {
      errorMessage = error = invalid.charge.required_all;
    }

    charge.id = 'default';

    return (
      <>
        <div
          className='mc-modal-body'
          style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}
        >
          <div className='mc-form'>
            {this.renderChatTicket(charge, 'chatTicket', LANG_CONST.chat_ticket)}
            {!!error && <p className='mc-error'>{errorMessage}</p>}
          </div>
        </div>
        <NavigationButtons
          hide={this.props.close}
          prev={this.props.prev}
          next={() => model.saveCharges((err) => !err && this.props.next())}
          loading={loading}
          labelNext={this.props.labelNext}
        />
      </>
    );
  }
}
